import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"scale(.5455)\"><g clip-path=\"url(#phone-clip0_4159_827)\"><path fill=\"currentColor\" d=\"M35.305 43.115h-.23C8.489 41.585 4.715 19.154 4.187 12.307a4.06 4.06 0 0 1 3.734-4.37h7.455a2.71 2.71 0 0 1 2.516 1.705l2.057 5.06a2.7 2.7 0 0 1-.596 2.923l-2.881 2.909a12.68 12.68 0 0 0 10.255 10.282l2.936-2.909a2.71 2.71 0 0 1 2.936-.555l5.1 2.043a2.71 2.71 0 0 1 1.665 2.517v7.144a4.06 4.06 0 0 1-4.059 4.059M8.245 10.643a1.353 1.353 0 0 0-1.352 1.353v.109c.622 8.01 4.613 26.95 28.33 28.304a1.35 1.35 0 0 0 1.435-1.272v-7.225l-5.1-2.043-3.884 3.856-.65-.081c-11.77-1.475-13.366-13.246-13.366-13.367l-.082-.65 3.843-3.883-2.03-5.1z\"></path></g><defs><clipPath id=\"phone-clip0_4159_827\"><path fill=\"currentColor\" d=\"M.128 0h43.295v43.295H.128z\"></path></clipPath></defs></g>", 1)
  ]))]))
}
export default { render: render }